import 'spatial-navigation-polyfill';
import 'string.padstart';
import 'focus-options-polyfill';
import './fonts.js';

import { AppRegistry } from 'react-native';
import muxjs from 'mux.js';
import ResizeObserver from 'resize-observer-polyfill';
import smoothscroll from 'smoothscroll-polyfill';

import app from '../app.json';
import App from '../src/App.web';
import { isX1 } from '../src/helpers/Platform';

if (typeof window.ResizeObserver === 'undefined') {
  console.log('ResizeObserver not supported for this browser. Using polyfill.');
  window.ResizeObserver = ResizeObserver;
}

if (!Object.fromEntries) {
  console.log('Object.fromEntries not supported for this browser. Using polyfill.');
  require('object.fromentries').shim();
}

// Adds smoothscroll to web-based browsers (for X1 devices).
// Will not polyfill if smoothscroll is already detected.
smoothscroll.polyfill();

const isHermes = !!global.HermesInternal;

console.log(`Hermes ${isHermes ? 'en' : 'dis'}abled`);

window.muxjs = muxjs;

// If we are on x1, make window.$badger available
if (isX1) {
  if ($badger && $badger.active()) {
    window.$badger = $badger;
  } else {
    document.addEventListener('onMoneyBadgerReady', () => {
      window.$badger = $badger;
    });
  }
}

AppRegistry.registerComponent(app.name, () => App);

AppRegistry.runApplication(app.name, {
  rootTag: document.querySelector('#main'),
});
